/* unplugin-vue-components disabled */import script from "./boxiaoShare.vue?vue&type=script&setup=true&lang=js"
export * from "./boxiaoShare.vue?vue&type=script&setup=true&lang=js"

import "./boxiaoShare.vue?vue&type=style&index=0&id=01cec9e7&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01cec9e7"]])

export default __exports__